<template>
  <div class="huanqiu-bind-building-page">
    <topNav title="楼栋绑定"
            url='/opera/centerHuanQiu'></topNav>
    <div class="ordertop">
      <div class="search">
        <input type="text"
               v-model='loginName'
               name=""
               :placeholder="$t('userCode')">
        <div class="cleartext"
             @click="loginName='';getList();"
             v-if="loginName != ''">
          <i class="iconfont icon-cuowu"></i>
        </div>
      </div>
      <div class="searchBtn"
           @click="getList">{{ $t('search') }}
      </div>
    </div>
    <div class="list-container">
      <mt-cell-swipe v-for="(item, index) in dataList" :key="index" :right="[{
                              content: $t('delete'),
                              style: {background: 'orange', color: '#fff',lineHeight:'89px' },
                              handler:function(){deleteItem(item)}
                          }]">
        <div class="list-item">
          <div class="list-line">
            <div class="line-title">登录账号:</div>
            <div class="line-content">{{item.loginName}}</div>
          </div>
          <div class="list-line">
            <div class="line-title">已绑楼栋:</div>
            <div class="line-content green">{{item.bindBuildings}}</div>
          </div>
        </div>
      </mt-cell-swipe>

      <div class="loadingli"
           v-show="loading">
        <mt-spinner :type="2"></mt-spinner>
      </div>
      <nothing :condition="!dataList || (dataList.length == 0)"></nothing>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import nothing from "../common/nothing";
import topNav from "../common/topNav";
import {
  CellSwipe,
  InfiniteScroll,
  Toast,
  MessageBox
} from "mint-ui";

export default {
  data() {
    return {
      dataList: [],
      totalCount: 0,
      loading: false,
      loginName: '',
    };
  },
  computed: {},
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.$http.get("/mobilepmsapi/opera/biz/selectRoomInAll?loginName=" + this.loginName)
        .then(res => {
          if (res.data.result == 0) {
            if (this.dataList == null) {
              this.dataList = [];
            }
            this.dataList = res.data.retVal;
            this.loading = false;
          } else {
            this.msg(res.data.msg);
          }
        });
    },
    deleteItem(item) {
      MessageBox.confirm('确定删除该用户的绑定楼栋吗?')
        .then(action => {
          if (action == 'confirm') {
            this.$http.post("/mobilepmsapi/opera/biz/deleteRoomInById", {
              id: item.id,
              mac: localStorage.getItem('hbuilderXNewUUID') || 'no mac',
              oldValue: item.bindBuildings,
              newValue: '',
              operateItem: item.loginName,
            }).then(res => {
              if (res.data.result == 0) {
                this.msg("删除成功");
                this.getList()
              }
            });
          }
        })
    },
    msg(msg) {
      Toast({
        message: msg,
        position: "bottom",
        duration: 3000
      });
    }
  },
  filters: {
    dateF(value) {
      return value != "" ? value.replace(/-/g, "/").substring(5, 10) : "";
    },
    ddate(value) {
      if (value != null && value != "") {
        let arr = value.split(",");
        if (arr.length == 2) {
          return arr[0].substring(0, 10) + " -- " + arr[1].substring(0, 10);
        }
      }
      return value;
    },
    fdate(value) {
      return value == null || value == "" ?
        null :
        moment(value).format("YYYY-MM-DD");
    }
  },
  components: {
    nothing,topNav
  }
};
</script>

<style lang="less">
.huanqiu-bind-building-page {
  overflow: auto;

  .mint-cell {
    border-radius: 15px;
    margin-bottom: 15px;
    background: #eee;
    .mint-cell-title {
      display: none;
    }
    .mint-cell-value {
      width: 100%;
      flex: 1;
    }
  }

  .list-container {
    width: 100%;
    padding: 15px;
    box-sizing: border-box;

    .list-item{
      width: 100%;
      background: #eee;
      border-radius: 10px;
      padding: 20px 15px 10px;

      .list-line{
        display: flex;
        margin-bottom: 15px;
        font-size: 14px;

        .line-title {
          color: #333;
          margin-right: 15px;
        }

        .line-content{
          color: #666;
          max-width: 60%;
          word-break: break-all;
        }
        .green{
          color: green;
        }
      }
    }
  }

  .ordertop {
    height: 1.15rem;
    width: 100%;
    margin-top: -1px;
    background: #eee;
    padding: 0.18666667rem 0;
    box-sizing: border-box;
    top: 37px;
    z-index: 98;
    display: flex;

    .search {
      margin-left: 0.34666667rem;
      border-radius: 0.44rem;
      width: 70%;
      float: left;
      height: 0.8rem;
      background-color: #f7f8fa;
      padding: 0 0.26666667rem;
      overflow: hidden;
      box-sizing: border-box;

      i.icon-sousuo {
        vertical-align: bottom;
        font-size: 0.42666667rem;
        color: #ccc;
        line-height: 0.89333333rem;
      }

      input {
        padding-left: 0.2rem;
        width: 70%;
        vertical-align: middle;
        height: 0.853333rem;
        background-color: #f7f8fa;
        outline: 0;
        border: 0;
      }

      .cleartext {
        float: right;
        display: block;
        i.icon-cuowu {
          line-height: 0.32rem;
          background-color: #c3c3c3;
          border-radius: 50%;
          font-size: 0.32rem;
          text-align: center;
          color: #fff;
          padding: 0.13333333rem;
          margin-top: 0.13333333rem;
          -webkit-transform-origin-x: 0;
          transform: scale(0.6);
          -webkit-transform: scale(0.6);
          width: 0.32rem;
          display: inline-block;
        }
      }
    }

    .searchBtn {
      width: 1.73333333rem;
      text-align: center;
      float: left;
      line-height: 0.85rem;
      font-size: 0.32rem;
      color: #333333;
      flex: 1;
      background: #ddd;
      margin: 0 0.2rem;
      margin-right: 0.34666667rem;
      border-radius: 3px;
      &:active {
        background: #ccc;
      }
    }

    .mint-button {
      height: 100%;
      background: #fff;
      box-shadow: none;
      padding: 0;

      .fliter {
        width: 1.86666667rem;
        float: left;
        font-size: 0.32rem;
        line-height: 0.89333333rem;
        text-align: right;
        box-sizing: border-box;
        color: #5b5b5b;

        .iconfont {
          display: inline-block;
          margin-left: 0.13333333rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// bindBuildingHuanQiu.vue?78e318e4